import { apiClient } from '@shared/utils/api/client';

const PERMISSIONS_API_PATHS = {
  myModules: '/v1/api/platform/permissions/my-modules',
} as const;

let cachedModules: string[] | null = null;

export class PermissionsService {
  static async fetchMyModules(): Promise<string[]> {
    if (cachedModules) {
      return cachedModules;
    }

    const response = await apiClient.get<string[]>(PERMISSIONS_API_PATHS.myModules);
    const modules = response.data ?? [];

    cachedModules = modules;
    return modules;
  }

  static clearCache(): void {
    cachedModules = null;
  }
}

export default PermissionsService;
